// extracted by mini-css-extract-plugin
export default {"header-user":"User_header-user__vfiPw","Img":"User_Img__RVswB","user-name":"User_user-name__5JpLw"};